import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import BedarraIslandScubaDiving from "../pages/bedarra-island-scuba-diving/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <BedarraIslandScubaDiving />,
  },
  {
    path: "/bedarra-island-scuba-diving",
    element: <BedarraIslandScubaDiving />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
